module.exports = __webpack_public_path__ + "img/IMG_2024_L_BlackMatted.788a0633.jpg";